const GET_CATEGORIES = "GET_CATEGORIES";
const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
const GET_CATEGORIES_FAILURE = "GET_CATEGORIES_FAILURE";
const CLEAR_GET_CATEGORIES = "CLEAR_GET_CATEGORIES";
const ADD_CATEGORY_SUCCESS = "ADD_CATEGORY_SUCCESS";
const categorySymbols = {
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAILURE,
  GET_CATEGORIES,
  CLEAR_GET_CATEGORIES,
  ADD_CATEGORY_SUCCESS,
};
export default categorySymbols;
